<template>
  <div ref="pdfContent" class="pdf-content">
    <CCard class="border-0">
      <CCardHeader v-if="!hideControls" class="no-print bg-transparent">
        <div class="float-right">
          <a href="#" class="btn btn-sm btn-info ml-1" @click="printContent">
            <CIcon name="cil-print" class="mr-1" /> Print
          </a>
        </div>
      </CCardHeader>
      <CCardBody>
        <!-- Company Header -->
        <div class="header">
          <CRow class="align-items-start mb-3">
            <CCol cols="3" md="2" class="text-left">
              <img
                :src="getImageUrl()"
                alt="Logo Syarikat"
                class="logo-image"
              />
            </CCol>
            <CCol cols="9" md="10" class="text-right company-info">
              <h1 class="company-name">{{ company.name }}</h1>
              <p class="company-tagline">{{ company.tagLine }}</p>
              <p class="company-regno">{{ "(" + company.regNo + ")" }}</p>
              <p class="company-address" v-html="formatAddress(company.address)"></p>
              <p class="company-phone">TEL : {{ company.phone }}</p>
            </CCol>
          </CRow>
          <hr class="thick-hr" />
        </div>

        <!-- Letter Content -->
        <div class="letter-content">
          <!-- Recipient -->
          <div class="recipient-section mb-3">
            <p class="mb-1"><strong>The Manager</strong></p>
            <p class="mb-1"><strong>{{ bank.name || 'BANK NAME' }}</strong></p>
          </div>

          <div class="mb-3">
            <p class="mb-1">Dear Sirs/Mdm,</p>
          </div>

          <div class="mb-3 text-right">
            <p><strong>DATE :</strong> {{ getCurrentDate() }}</p>
          </div>

          <!-- Subject -->
          <div class="subject-section mb-3">
            <p><strong><u>RE: JPJ E-HAKMILIK REQUEST</u></strong></p>
          </div>

          <!-- Vehicle and Hirer Information Table -->
          <table class="table table-bordered table-sm info-table">
            <tbody>
              <tr>
                <td class="label-column"><strong>NAME OF HIRER:</strong></td>
                <td class="value-column">{{ getCustomerName() }}</td>
              </tr>
              <tr>
                <td class="label-column"><strong>IC NO/BUSINESS REGN.:</strong></td>
                <td class="value-column">{{ getCustomerIcNumber() }}</td>
              </tr>
              <tr>
                <td class="label-column"><strong>VEHICLE DESCRIPTION:</strong></td>
                <td class="value-column">{{ getVehicleDescription() }}</td>
              </tr>
              <tr>
                <td class="label-column"><strong>YOM:</strong></td>
                <td class="value-column">{{ getYear() }}</td>
              </tr>
              <tr>
                <td class="label-column"><strong>CHASSIS NO:</strong></td>
                <td class="value-column">{{ getChassisNo() }}</td>
              </tr>
              <tr>
                <td class="label-column"><strong>ENGINE NO:</strong></td>
                <td class="value-column">{{ getEngineNo() }}</td>
              </tr>
              <tr>
                <td class="label-column"><strong>TENURE:</strong></td>
                <td class="value-column">{{ getTenure() }}</td>
              </tr>
              <tr>
                <td class="label-column"><strong>HP SERIAL:</strong></td>
                <td class="value-column">{{ getHpSerial() }}</td>
              </tr>
              <tr>
                <td class="label-column"><strong>HIRE PURCHASE:</strong></td>
                <td class="value-column">{{ getHirePurchaseBank() }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Closing -->
          <div class="closing-section mt-4">
            <p>Thank you</p>
            <p><i>for</i> <strong>{{ company.name }}</strong></p>
            <br />
            <br />
            <br />
            <div class="signature-line"></div>
            <p><strong>Manager</strong></p>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "WidgetsReportEHakmilik",
  props: {
    stock: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
      validator: (value) => {
        return ["name", "tagLine", "address", "phone", "logoUrl"].every(
          (prop) => prop in value
        );
      },
    },
    bank: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    hideControls: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.forceA4Size();
  },
  methods: {
    forceA4Size() {
      const pdfContent = this.$refs.pdfContent;
      if (pdfContent) {
        pdfContent.style.width = "210mm";
      }
    },
    removeTrailingSlash(str) {
      if (str.endsWith("/")) {
        return str.slice(0, -1);
      }
      return str;
    },
    getImageUrl() {
      var url = this.removeTrailingSlash(apiUrl) + this.company.logoUrl;
      return url;
    },
    formatAddress(address) {
      if (!address) return "";
      return address.replace(/\n/g, "<br />");
    },
    getCurrentDate() {
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, "0");
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const year = currentDate.getFullYear();
      return `${day}.${month}.${year}`;
    },
    getCustomerName() {
      try {
        return this.stock.sale?.customer?.name || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    getCustomerIcNumber() {
      try {
        return this.stock.sale?.customer?.icNumber || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    getVehicleDescription() {
      try {
        const brand = this.stock.vehicle?.brand?.name || "";
        const model = this.stock.vehicle?.model?.name || "";
        if (!brand && !model) return "N/A";
        return `${brand} ${model}`.trim();
      } catch (error) {
        return "N/A";
      }
    },
    getYear() {
      try {
        return this.stock.vehicle?.year || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    getChassisNo() {
      try {
        return this.stock.vehicle?.chasisNo || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    getEngineNo() {
      try {
        return this.stock.vehicle?.engineNo || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    getTenure() {
      try {
        const tenure = this.stock.sale?.loan?.loanTenure;
        return tenure ? `${tenure}` : "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    getHpSerial() {
      try {
        return this.stock.sale?.loan?.hpSerial || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    getHirePurchaseBank() {
      try {
        return this.bank.name || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    printContent() {
      const printContents = this.$refs.pdfContent.innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.pdf-content {
  width: 210mm;
  max-width: 100%;
  margin: 0 auto;
  padding: 15mm;
  box-sizing: border-box;
  background-color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.3;
  color: #333;
}

.logo-image {
  max-width: 120px;
  height: auto;
  display: block;
}

.header {
  page-break-after: avoid;
  page-break-inside: avoid;
  margin-bottom: 15px;
}

.company-info {
  padding-left: 15px;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
  line-height: 1.2;
}

.company-tagline,
.company-regno,
.company-address,
.company-phone {
  margin-bottom: 3px;
  font-size: 11px;
  line-height: 1.3;
}

.thick-hr {
  border: none;
  border-top: 2px solid #333;
  margin: 10px 0;
}

.letter-content {
  margin-top: 20px;
  font-size: 0.95rem;
}

.recipient-section p {
  margin-bottom: 0.25rem;
  line-height: 1.4;
}

.subject-section {
  text-align: center;
}

.subject-section p {
  font-size: 1rem;
}

/* Table Styles */
.table {
  width: 100%;
  page-break-inside: auto;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.table-sm td {
  padding: 5px 8px !important;
  line-height: 1.3;
  vertical-align: middle;
}

.table tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

/* Info Table (Vertical Layout) */
.info-table .label-column {
  width: 35%;
  background-color: #f8f9fa;
  font-weight: bold;
  text-align: left;
}

.info-table .value-column {
  width: 65%;
  text-align: left;
}

.closing-section {
  margin-top: 30px;
}

.signature-line {
  width: 200px;
  border-bottom: 1px solid #000;
  margin: 10px 0;
}

/* Print Styles */
@media print {
  .no-print {
    display: none !important;
  }

  body {
    background: white;
  }

  .pdf-content {
    padding: 10mm;
    width: 210mm;
    margin: 0;
  }

  .logo-image {
    max-width: 100px !important;
  }

  .table {
    font-size: 10px;
  }

  .table-sm td {
    padding: 4px 6px !important;
    line-height: 1.2 !important;
    font-size: 10px !important;
  }

  .info-table .label-column {
    font-size: 10px !important;
  }

  .info-table .value-column {
    font-size: 10px !important;
  }

  .company-name {
    font-size: 18px !important;
  }
}

/* PDF Generation Specific Styles */
.pdf-content.pdf-generation {
  width: 794px !important;
  padding: 0 !important;
  margin: 0;
}

.pdf-content.pdf-generation .card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.pdf-content.pdf-generation .card-body {
  padding: 0 !important;
}

.pdf-content.pdf-generation .no-print {
  display: none !important;
}

.pdf-content.pdf-generation .logo-image {
  max-width: 100px !important;
}

.pdf-content.pdf-generation .company-name {
  font-size: 18px !important;
}
</style>
